import React from 'react';
import WineCard from './WineCard';

const WineCarousel = ({ 
  wines = [], 
  currentIndex = 0, 
  onNext, 
  onPrevious, 
  onSelect,
  onTellMeMore,
  isLoading = false
}) => {
  const currentWine = wines[currentIndex];
  
  if (!currentWine) {
    return (
      <div className="wine-carousel-container">
        <div className="wine-card-wrapper">
          <div className="wine-style-card carousel-card">
            <p>No wine data available</p>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="wine-carousel-container">
      <div className="wine-card-wrapper">
        <button 
          className="carousel-nav-floating prev" 
          onClick={onPrevious}
          disabled={currentIndex === 0}
          aria-label="Previous wine"
        >
          ◄
        </button>
        
        <WineCard 
          wine={currentWine}
          onTellMeMore={onTellMeMore}
          isLoading={isLoading}
        />
        
        <button 
          className="carousel-nav-floating next" 
          onClick={onNext}
          disabled={currentIndex === wines.length - 1}
          aria-label="Next wine"
        >
          ►
        </button>
      </div>
      
      <div className="wine-carousel-header">
        <div className="carousel-dots">
          {wines.map((_, index) => (
            <button
              key={index}
              className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => onSelect(index)}
              aria-label={`Go to wine ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default WineCarousel;
